import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Logger } from "../../infra/logger/logger";
import { BaseInputFilter } from "domain/models/base-input-filter";
import tripsheetReportRepository from "infra/repositories/tripsheet-report-repository";

export const useTripsheetReport = (id?: string, filter?: BaseInputFilter) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["tripsheetReport", id],
    queryFn: async () => {
      try {
        if (!id) throw new Error("Tripsheet ID inválido");
        const result = await tripsheetReportRepository.getTripsheetReport(
          id,
          filter
        );
        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: 0,
    enabled: false,
  });
};
